import React, { useState, useEffect } from 'react';
import { cloudAPI } from '../../utils/api';

export default function GeoPage() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cloudAPI.getGeo()
            .then(res => {
                const d = res.data;
                const rows = Array.isArray(d) ? d
                           : Array.isArray(d?.data) ? d.data
                           : Array.isArray(d?.rows) ? d.rows
                           : Array.isArray(d?.regions) ? d.regions
                           : [];
                setData(rows);
            })
            .catch(err => console.error('Geo error:', err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="text-gray-400">Loading...</div>;

    return (
        <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Geography</h2>
            <div className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Users by Region</h3>
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Country</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Installs</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pro Users</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Avg RAM</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Top Manufacturer</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {data.map((row, idx) => (
                                <tr key={idx} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{row.country || '—'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{row.installs || 0}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{row.pro_users || 0} ({row.pro_pct || 0}%)</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{row.avg_ram_mb ? `${row.avg_ram_mb} MB` : '—'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{row.top_manufacturer || '—'}</td>
                                </tr>
                            ))}
                            {data.length === 0 && (
                                <tr><td colSpan="5" className="px-6 py-6 text-sm text-gray-400 text-center">No geo data yet</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
